import React from "react";
import { Breadcrumb } from "react-bootstrap";

const constructBreadcrumbItems = (breadcrumbs, onBreadcrumbClick) => {
  var items = [];

  for (var i = 0; i < breadcrumbs.length; i++) {
    const breadcrumb = breadcrumbs[i];
    const breadcrumbPosition = i;
    const current = i === breadcrumbs.length - 1;
    const item = (
      <Breadcrumb.Item
        key={i}
        active={current}
        href={breadcrumb.path}
        onClick={event => {
          event.preventDefault();
          if (!current) {
            onBreadcrumbClick(breadcrumb, breadcrumbPosition);
          }
        }}
      >
        {breadcrumb.name}
      </Breadcrumb.Item>
    );
    items.push(item);
  }

  return items;
};

const Breadcrumbs = ({ breadcrumbs, onClick }) => {
  const items = constructBreadcrumbItems(breadcrumbs, onClick);

  return <Breadcrumb bsPrefix="Breadcrumb">{items}</Breadcrumb>;
};

export default Breadcrumbs;
